<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" :title="onDialogTitle">
        <v-form lazy-validation ref="form">
          <div class="mt-2">
            <span class="red--text">*</span> 는 필수입력항목입니다.
          </div>
          <v-row align="center">
            <v-col cols="12" md="4">
              <span class="font-weight-black">센터</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8">
              <v-select
                v-model="centerId"
                :items="centerInfo"
                solo
                menu-props="{ offsetY: true}"
                hide-details
                required
                :rules="[v => !!v]"
                label="센터를 선택해주세요"
              ></v-select>
            </v-col>

            <v-col cols="12" md="4">
              <span class="font-weight-black">타입</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8" v-if="adminFormData">
              <span>{{authority}}</span>
            </v-col>
            <v-col cols="12" md="8" v-if="!this.adminFormData">
              <v-select
                v-model="authority"
                :items="authorities"
                solo
                menu-props="{ offsetY: true}"
                hide-details
                label="관리자 타입을 선택해주세요"
              ></v-select>
            </v-col>

            <v-col cols="12" md="4">
              <span class="font-weight-black">메뉴 권한</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8" v-if="adminFormData">
              <span>{{ menuRole? menuRole.name : '-' }}</span>
            </v-col>
            <v-col cols="12" md="8" v-if="!this.adminFormData">
              <v-select
                v-model="menuRole"
                :items="roleList"
                item-text="name"
                item-value="id"
                solo
                menu-props="{ offsetY: true}"
                hide-details
                label="권한을 선택해주세요"
              ></v-select>
            </v-col>



            <v-col cols="12" md="4">
              <span class="font-weight-black">아이디</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8">
              <span v-if="adminFormData">{{loginId}}</span>
              <v-row v-else>
                <v-col cols="8">
                  <v-text-field
                    v-model="loginId"
                    :rules="[rules.requiredId]"
                    solo
                    maxlength="32"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <c-btn
                    class="mt-2"
                    color="blue"
                    outlined
                    @click="idDuplicateCheck"
                  >중복검사
                  </c-btn>
                </v-col>
              </v-row>
            </v-col>
            <!--todo 현재 비밀번호-->
            <v-col cols="12" md="4" v-if="this.adminFormData">
              <span class="font-weight-black">현재 비밀번호</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8" v-if="this.adminFormData">
              <v-text-field
                :type="pwdShow3 ? 'text' : 'password'"
                v-model="currentPwd"
                :append-icon="pwdShow3 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.requiredPass]"
                @click:append="pwdShow3 = !pwdShow3"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <span class="font-weight-black">비밀번호</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                :type="pwdShow ? 'text' : 'password'"
                v-model="password"
                :append-icon="pwdShow ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.requiredPass, passwordValidationRule]"
                @click:append="pwdShow = !pwdShow"
                solo
                maxlength="64"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
            </v-col>
            <v-col cols="12" md="8" style="paddig-top:0px;">
              [비밀번호 설정 가이드라인]<br>
              - 비밀번호는 8~16자로 설정해주세요.<br>
              - 영문, 특수문자를 포함하면 더욱 안전한 계정 관리가 가능합니다.
            </v-col>
            <v-col cols="12" md="4">
              <span class="font-weight-black">비밀번호 확인</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                :type="pwdShow2 ? 'text' : 'password'"
                v-model="loginPwdConfirm"
                :append-icon="pwdShow2 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="pwdShow2 = !pwdShow2"
                :rules="[rules.requiredPass, passwordConfirmationRule]"
                solo
                maxlength="64"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <span class="font-weight-black">이름</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8">
              <span v-if="adminFormData">{{name}}</span>
              <v-text-field
                v-else
                v-model="name"
                :rules="[rules.requiredName]"
                solo
                maxlength="32"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <span class="font-weight-black">연락처</span><span class="red--text"> * </span>
            </v-col>
            <v-col cols="12" md="8">
<!--              <v-text-field-->
<!--                placeholder="000-0000-0000"-->
<!--                v-model="extension"-->
<!--                v-mask="mask"-->
<!--                :rules="[rules.requiredEx]"-->
<!--                solo-->
<!--              ></v-text-field>-->
              <v-row justify="space-around" align="center">
                <v-col cols="3" class="mr-0 pr-0">
                  <v-text-field
                    v-model="mobileNo1"
                    solo
                    hide-details
                    required
                    :rules="[rules.requiredEx]"
                    dense
                    :autofocus="true"
                    v-mask="['##', '###']"
                    color="navy"></v-text-field>
                </v-col>
                <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
                <v-col cols="3" class="mx-0 px-0">
                  <v-text-field
                    id="mobileNo2A"
                    v-model="mobileNo2"
                    solo
                    hide-details
                    required
                    :rules="[rules.requiredEx]"
                    dense
                    :autofocus="true"
                    v-mask="['###', '####']"
                    color="navy"></v-text-field>
                </v-col>
                <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
                <v-col cols="3" class="ml-0 pl-0">
                  <v-text-field
                    id="mobileNo3A"
                    v-model="mobileNo3"
                    solo
                    hide-details
                    required
                    :rules="[rules.requiredEx]"
                    dense
                    :autofocus="true"
                    v-mask="['####']"
                    color="navy"></v-text-field>
                </v-col>
              </v-row>

            </v-col>
          </v-row>
          <v-row justify="center">
            <c-btn v-if="adminFormData" class="mr-1 mt-2" color="blue" outlined @click="onUpdateAdmin">수정</c-btn>
            <c-btn v-else class="mr-1 mt-2" color="blue" outlined @click="onAddAdmin">등록</c-btn>
            <c-btn class="mt-2" color="grey" outlined @click="openFlag = false">취소</c-btn>
          </v-row>
        </v-form>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import {mask} from 'vue-the-mask';

  export default {
    directives: {mask},
    props: {
      open: {
        type: Boolean,
        default: false
      },
      adminFormData: {
        type: Object,
        default: undefined
      },
    },
    data: () => ({
      openFlag: false,

      pwdShow: false,
      pwdShow2: false,
      pwdShow3: false,

      rules: {
        requiredPass: (value) => !!value || '비밀번호를 입력하세요.',
        requiredEx: (value) => !!value || '연락처를 입력하세요.',
        requiredId: (value) => !!value || '아이디를 입력하세요',
        requiredName: (value) => !!value || '이름을 입력하세요',
      },

      // admin info
      id: '',
      loginId: '',
      password: '',
      loginPwdConfirm: '',
      centerId: '',
      authority: '',

      menuRole: '',

      name: '',
      extension: '',
      currentPwd:'',

      centerInfo: [],
      authorities:[],

      // 중복된 아이디 여부
      availableId: true,
      checkingId: false,

      // dialog title
      dialogTitle: '',


      mobileNo1: '',
      mobileNo2: '',
      mobileNo3: '',


      mobileNoRegx: /^(01[16789]|02|0[3-9][0-9])-[0-9]{3,4}-[0-9]{4}$/,
      mobileNoRegx010: /^(010)-[0-9]{4}-[0-9]{4}$/,
      mask: '###-####-####',

      roleList: [],
    }),
    mounted() {
    },
    watch: {
      async open(value) {
        if(value) {
          this.initData();
          await this.reqGetCenter();
          await this.reqGetRoleList();

          if(this.adminFormData) {
            this.id = this.adminFormData.id;
            this.centerId = this.adminFormData.centerId.id;
            this.loginId = this.adminFormData.loginId;
            this.password = this.adminFormData.password;
            this.name = this.adminFormData.name;
            this.extension = this.adminFormData.extension;
            this.authority = this.adminFormData.authority;
            this.menuRole = this.adminFormData.menuRole;
            if (this.extension) {
              this.mobileNo1 = this.extension.split('-')[0];
              this.mobileNo2 = this.extension.split('-')[1];
              this.mobileNo3 = this.extension.split('-')[2];
            }
          }
        }
        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
      // id 변경되었을 때 중복체크 플래그 초기화
      loginId() {
        this.checkingId = false;
      },
      mobileNo1(value) {
        if(this.customerFormData === undefined){
          this.mobileNoFlag = false;
        }
        if(value === '02' || value.length === 3) {
          document.getElementById("mobileNo2A").focus()
        }
      },
      mobileNo2(value) {
        if(this.customerFormData === undefined){
          this.mobileNoFlag = false;
        }
        if(value.length === 4) {
          document.getElementById("mobileNo3A").focus()
        }
      },
      mobileNo3(value) {
        if(this.customerFormData === undefined){
          this.mobileNoFlag = false;
        }
      },
    },
    computed: {
      passwordValidationRule() {
        return () => (this.password.length >= 8 && this.password.length <= 16) || '비밀번호는 8~16자로 설정해주세요.'
      },
      passwordConfirmationRule() {
        return () => (this.password === this.loginPwdConfirm) || '비밀번호가 일치하지 않습니다.'
      },
      onDialogTitle() {
        return this.adminFormData ? '관리자 계정 정보 수정' : '관리자 계정 등록';
      },
    },
    methods: {
      idDuplicateCheck() {
        this.reqGetAdmin();
      },
      initData() {
        this.centerId = '';
        this.authority = '';
        this.loginId = '';
        this.currentPwd = '';
        this.password = '';
        this.loginPwdConfirm = '';
        this.name = '';
        this.extension = '';
        this.availableId = false;
        this.mobileNo1 = '';
        this.mobileNo2 = '';
        this.mobileNo3 = '';
        this.menuRole = '';
      },

      // 중복 검사를 위한 id 조회
      async reqGetAdmin() {
        try {
          const res = await this.$api.getAdmin(this.loginId);
          this.availableId = !!!(res.data);

          if (this.availableId) {
            this.$store.commit('snackbar', {timeout: 2000, msg: '사용 가능한 아이디입니다.'});
            this.checkingId = true;
          } else {
            this.$store.commit('snackbar', {timeout: 2000, msg: '중복된 아이디입니다.'});
          }

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetCenterAdmin'});
        }
      },

      onAddAdmin() {
        if (!(this.$refs.form.validate())) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '입력 정보를 다시 확인해주세요.'});
          return;
        }

        if (!(this.checkingId)) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '아이디 중복체크를 해주세요.'});
          return;
        }

        this.extension = this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3;
        if(!this.mobileRegxCheck(this.extension)) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
          return;
        }

        if(!this.menuRole) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '메뉴 권한을 선택해주세요.'});
          return ;
        }

        let reqData = {
          centerId: this.centerId,
          authority: this.authority,
          loginId: this.loginId,
          password: this.password,
          name: this.name,
          extension: this.extension,
          menuRole: this.roleList.find(item => item.id === this.menuRole)
        };

        this.$emit('reqAddAdmin', reqData);
      },

      onUpdateAdmin() {
        if (!(this.$refs.form.validate())) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '입력 정보를 다시 확인해주세요.'});
          return;
        }

        this.extension = this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3;
        if(!this.mobileRegxCheck(this.extension)) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
          return;
        }

        let reqData = {
          id: this.id,
          centerId: this.centerId,
          loginId: this.loginId,
          password: this.password,
          name: this.name,
          extension: this.extension,
          currentPwd: this.currentPwd,
          menuRole: this.menuRole,
        };

        this.$emit('reqUpdateAdmin', reqData);

      },

      async reqGetCenter() {
        try {
          const res = await this.$api.getCenter(this.$store.state.service);
          let centerInfo = [];
          let authorities = [];

          if(this.$store.state.userInfo.role === 'SA') { //super 일 경우
            for (const i in res.data) {
              centerInfo.push({text: res.data[i].centerName, value: res.data[i].id})
            }

            authorities.push({text : '슈퍼어드민 (이동의 자유 관계자)', value: 'SA'});
            authorities.push({text : '어드민 (센터 담당자)', value: 'admin'});
            authorities.push({text : '유저 (직원)', value: 'user'});
            authorities.push({text : '예약관리자 (직원)', value: 'RM'});
            authorities.push({text : '모니터링관리자 (직원)', value: 'MM'});
            authorities.push({text : '임시관리자 (직원)', value: 'TM'});
          }
          else if(this.$store.state.userInfo.role === 'RM') { //super 일 경우
            for (const i in res.data) {
              if(res.data[i].centerName === this.$store.state.userInfo.centerName) {
                centerInfo.push({text: res.data[i].centerName, value: res.data[i].id});
              }
            }

            authorities.push({text : '예약관리자 (직원)', value: 'RM'});
          } else { // admin/ user 일 경우
            for (const i in res.data) {
              if(res.data[i].centerName === this.$store.state.userInfo.centerName) {
                centerInfo.push({text: res.data[i].centerName, value: res.data[i].id});
              }
            }

            authorities.push({text : '유저 (직원)', value: 'user'});
            authorities.push({text : '예약관리자 (직원)', value: 'RM'});
            authorities.push({text : '임시관리자 (직원)', value: 'TM'});
          }

          if(centerInfo.length > 0) this.centerId = centerInfo[0].value;
          if(authorities.length > 0) this.authority = authorities[0].value;
          this.centerInfo = centerInfo;
          this.authorities = authorities;

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetCenter'});
        }
      },

      mobileRegxCheck(number) {
        if(number === '') return true;
        if(this.mobileNo1 === '010') return this.mobileNoRegx010.test(number)
        else return this.mobileNoRegx.test(number)
      },
      async reqGetRoleList() {
        try {
          const res = await this.$api.getAdminRoleByCenterId();
          this.roleList = res.data;
          console.log('res/ reqGetRoleList : ', res.data);
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetRoleList'});
        }
      },
    },
  }
</script>
<style scoped>
</style>
